// Catálogo de voces (tabla `voces`) para el modo diálogo del Asistente V2.
//
// Misma fuente que usa el Director de Estudio para su selector de voz. Lectura
// pública (no se firma nada). Se inyecta al system prompt (texto: id + nombre +
// sexo + idioma/acento) para que el agente pueda preseleccionar una voz, y la
// usa el selector de voz inline de la card de video en modo diálogo.

import { supabase } from '../../lib/supabase';

export interface VoiceV2 {
  id: string;
  nombre: string;
  sexo: string | null;
  idioma: string | null;
  acento: string | null;
  descripcion: string | null;
  /** URL de preview reproducible (para escuchar la voz en el selector). */
  previewUrl: string | null;
}

/** Trae todas las voces, ordenadas por nombre. */
export async function fetchVoices(): Promise<VoiceV2[]> {
  const { data, error } = await supabase
    .from('voces')
    .select('id, nombre, sexo, descripcion, preview_url, idioma, acento')
    .order('nombre');
  if (error || !data) {
    if (error) console.error('[voicesApi] fetchVoices', error);
    return [];
  }
  return (data as any[]).map((v): VoiceV2 => ({
    id: String(v.id),
    nombre: (v.nombre as string) || 'Voz',
    sexo: (v.sexo as string) ?? null,
    idioma: (v.idioma as string) ?? null,
    acento: (v.acento as string) ?? null,
    descripcion: (v.descripcion as string) ?? null,
    previewUrl: (v.preview_url as string) ?? null,
  }));
}
